/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const BusinessUnit = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 17 17">
      <path d="M18.61,14.16V11a1,1,0,0,0-1-1H12.35V6.44a1.74,1.74,0,1,0-.7,0V10H6.43a1,1,0,0,0-1,1v3.16a1.74,1.74,0,1,0,.7,0V11a.35.35,0,0,1,.34-.35h5.22v3.51a1.74,1.74,0,1,0,.7,0V10.65h5.22a.35.35,0,0,1,.34.35v3.16a1.74,1.74,0,1,0,.7,0ZM6.78,15.87a1,1,0,1,1-1-1A1,1,0,0,1,6.78,15.87Zm6.26,0a1,1,0,1,1-1-1,1,1,0,0,1,1,1ZM12,5.78a1,1,0,1,1,1-1,1,1,0,0,1-1,1Zm6.26,11.13a1,1,0,1,1,1-1A1,1,0,0,1,18.26,16.91Z" transform="translate(-4 -3)" />
    </BaseSvgIcon>
  )
}

export default BusinessUnit
